module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-simple-columns3-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns n1 small-4"
  }, [_vm._t("n1")], 2), _c('div', {
    staticClass: "columns n2 small-4"
  }, [_vm._t("n2")], 2), _c('div', {
    staticClass: "columns n3 small-4"
  }, [_vm._t("n3")], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns n4 small-4"
  }, [_vm._t("n4")], 2), _c('div', {
    staticClass: "columns n5 small-4"
  }, [_vm._t("n5")], 2), _c('div', {
    staticClass: "columns n6 small-4"
  }, [_vm._t("n6")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1189f91b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/simpleColums3-3.vue
// module id = 2279
// module chunks = 1